// Human-friendly relative time formatter for presence timestamps.
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default function formatLastSeen(ts) {
  if (!ts) return 'unknown';
  const now = Date.now();
  const diff = Math.max(0, now - ts);

  if (diff < 15 * SECOND) return 'just now';
  if (diff < MINUTE) return `${Math.floor(diff / SECOND)}s ago`;
  if (diff < 90 * SECOND) return '1 minute ago';
  if (diff < 50 * MINUTE) return `${Math.floor(diff / MINUTE)} minutes ago`;
  if (diff < 90 * MINUTE) return '1 hour ago';
  if (diff < 20 * HOUR) return `${Math.floor(diff / HOUR)} hours ago`;
  if (diff < 36 * HOUR) return 'yesterday';
  return `${Math.floor(diff / DAY)} days ago`;
}
